import SvgIcon from "components/general/svgIconServices";
import PricingTwo from "components/home/pricingTwo";
import BottomContent from "components/services/bottomContent";
import DetailsTwo from "components/services/detailsTwo";
import Faq from "components/services/faq";
import Header from "components/services/header";
import { servicesSingleData } from "data/servicesSingleData";
import { deletableTypes } from "data/variables";
import Head from "next/head";
import { useEffect, useState } from "react";
import styled from "styled-components";

const StyledWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 2rem;
`;
const StyledRow = styled.div`
  display: flex;
  margin-bottom: 3rem;
  width: 100%;
  align-items: center;
  gap: 2rem;
  h3 {
    margin-top: 0;
    font-size: 1.6rem;
    line-height: 2rem;
  }
  @media screen and (max-width: 992px) {
    flex-direction: column !important;
    align-items: flex-start;
  }
`;

const StyledImage = styled.img`
  max-width: 100%;
  margin-top: 1rem;
  border-radius: 1rem;
  overflow: hidden;
  width: ${(props) => props.width || "540px"};
`;
const StyledBodyWrapper = styled.div`
  flex: 1;
  padding: 0;
`;

const StyledRowContent = styled.div`
  flex: 1;
  @media screen and (max-width: 768px) {
    padding: 0 1rem;
  }
`;
const createMarkup = (textValue) => {
  return { __html: textValue };
};

const StyledRowWrapper = styled.div`
  display: flex;
  background: var(--raised-background-color);
  padding: 2rem;
  margin: 2rem 0;
  > div {
    flex: 1;
    &:first-child {
      flex: 2;
    }
  }
  @media screen and (max-width: 992px) {
    flex-direction: column-reverse;
  }
  &:nth-child(even) {
    ${StyledRow} {
      flex-direction: row-reverse;
    }
  }
`;

const StyledError = styled.div`
  background: #f9d7da;
  color: #802b29;
  border-radius: 3px;
  max-width: calc(100% - 2rem);
  width: 700px;
  padding: 1rem 1.5rem;
`;

const ServicesSingleDoc = ({ setDark, singleData, slug }) => {
  useEffect(() => {
    if (singleData.textDark) {
      setDark(true);
      return () => {
        setDark(false);
      };
    }
  }, [setDark, singleData.textDark]);

  const [flags, setFlags] = useState({});
  useEffect(() => {
    fetch("https://client-metadata.redact.dev/main/flags.json")
      .then((res) => res.json())
      .then((body) => setFlags(body));
  }, []);
  const title = `Mass delete ${singleData.title} ${deletableTypes[singleData.icon] || "messages"}`;
  return singleData ? (
    <>
      <Head>
        <title>{singleData.uniquetitle}</title>
        <meta charSet="utf-8" />
        <link rel="icon" href="/images/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="theme-color" content="#000000" />
        <meta name="robots" content="noarchive" />
        <meta name="description" content={singleData.description} />
        <meta name="keywords" content={`redact mass delete privacy ${singleData.title}`} />

        <meta
          property="og:title"
          content={`Redact - Mass delete ${singleData.title} ${
            deletableTypes[singleData.icon] || "messages"
          }`}
        />
        <meta property="og:description" content={singleData.description} />
        <meta property="og:url" content={`https://www.redact.dev/services/${slug}`} />
        <link rel="apple-touch-icon" href="images/logo192.png" />
      </Head>
      <div key={singleData.title}>
        <Header singleData={singleData} />
        {flags[`axe.${slug}.killswitch`] && (
          <div style={{ display: "flex", justifyContent: "center", margin: "1rem 0" }}>
            <StyledError>
              This service is currently undergoing maintenance and is not functional.
            </StyledError>
          </div>
        )}
        <DetailsTwo singleData={singleData} />
        <StyledWrapper>
          <StyledContainer>
            <StyledBodyWrapper>
              {singleData.details?.map((value) => {
                return (
                  <StyledRowWrapper key={value.uniqueKey}>
                    <StyledRow key={value.uniqueKey} name={value.uniqueKey}>
                      <StyledRowContent>
                        {value.icon && (
                          <SvgIcon name={value.icon} style={{ marginBottom: "2rem" }} />
                        )}
                        <h3>{value.title}</h3>
                        {value.text && (
                          <div
                            className="max-w-[700px] [&_ul]:ml-[1.2rem] [&_ul]:list-disc"
                            dangerouslySetInnerHTML={createMarkup(value.text)}
                          />
                        )}
                      </StyledRowContent>
                      {value.image && <StyledImage src={value.image} alt={value.title} />}
                    </StyledRow>
                  </StyledRowWrapper>
                );
              })}
            </StyledBodyWrapper>
          </StyledContainer>
        </StyledWrapper>
        {singleData.faqData && <Faq faqData={singleData.faqData} />}
        <BottomContent singleData={singleData} />
        <PricingTwo $noSpacing={true} />
      </div>
    </>
  ) : null;
};

export async function getStaticProps({ params }) {
  const singleData = servicesSingleData[params.slug];
  return {
    props: {
      singleData,
      slug: params.slug,
    },
  };
}
export async function getStaticPaths() {
  const posts = Object.keys(servicesSingleData);

  return {
    paths: posts.map((post) => {
      return {
        params: {
          slug: post,
        },
      };
    }),
    fallback: false,
  };
}

export default ServicesSingleDoc;
